import { useState } from "react";
import { SEOHead } from "@/components/SEOHead";
import { HeaderNavigation } from "@/components/HeaderNavigation";
import { FooterSEO } from "@/components/FooterSEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { PropertyCard } from "@/components/PropertyCard";
import { useListings } from "@/hooks/use-listings";
import { Building, Sparkles, MapPin, CheckCircle2 } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function LuxuryProjectsPage() {
  const { listings } = useListings();
  const luxuryListings = listings.filter((p) => p.category === "villa" || p.featured);

  return (
    <div className="min-h-screen bg-background flex flex-col justify-between">
      <SEOHead
        title="Adana Lüks Konut Projeleri & Rezidanslar | Corner Gayrimenkul"
        description="Çukurova Güzelyalı, Karslılar ve Seyhan Gürselpaşa göl manzaralı lüks villa, penthouse ve yeni site projeleri."
        canonicalPath="/luks-projeler"
      />
      <HeaderNavigation />

      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <Breadcrumbs items={[{ label: "Lüks Projeler" }]} />

        {/* Hero Section */}
        <div className="relative rounded-3xl overflow-hidden bg-slate-900 text-white p-8 sm:p-12 mb-12 shadow-2xl border border-slate-800">
          <div className="max-w-3xl space-y-4">
            <span className="px-3 py-1 rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/30 text-xs font-bold uppercase tracking-wider flex items-center gap-1.5 w-fit">
              <Sparkles className="h-3.5 w-3.5" /> Adana Premium Koleksiyon
            </span>
            <h1 className="text-3xl sm:text-5xl font-black tracking-tight leading-tight">
              Adana Lüks Konut Projeleri & Villalar
            </h1>
            <p className="text-slate-300 text-lg leading-relaxed">
              Seyhan Baraj Gölü manzaralı müstakil villalar, akıllı ev otomasyonlu penthouse daireler ve yüksek yaşam standartlı yeni rezidans projeleri.
            </p>
          </div>
        </div>

        {/* Features Card */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <Card className="p-6 bg-card border border-border">
            <Building className="h-8 w-8 text-amber-500 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Göl Manzaralı Villalar</h3>
            <p className="text-sm text-muted-foreground">Güzelyalı ve Karslılar mahallelerinde özel havuzlu müstakil yaşam.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <Sparkles className="h-8 w-8 text-amber-500 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Akıllı Ev Sistemleri</h3>
            <p className="text-sm text-muted-foreground">Yüksek güvenlikli, kapalı otoparklı ve sosyal donatılı lüks siteler.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <MapPin className="h-8 w-8 text-amber-500 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Prestijli Lokasyonlar</h3>
            <p className="text-sm text-muted-foreground">Turgut Özal ve Aliya İzzetbegoviç bulvarlarına yürüme mesafesinde konum.</p>
          </Card>
        </div>

        {/* Listings Grid */}
        <section className="mb-12">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-extrabold text-foreground">
              Seçkin Lüks Portföyler ({luxuryListings.length})
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {luxuryListings.map((prop) => (
              <PropertyCard key={prop.id} property={prop} />
            ))}
          </div>
        </section>
      </main>

      <FooterSEO />
    </div>
  );
}
